import axios from "axios"

export const BASE_URL=`${process.env.REACT_APP_STEELADMIN}`

export const myAxios=axios.create({
    baseURL: BASE_URL
})